import React from 'react';
import { observer } from 'mobx-react';
import { MembershipTypeStore } from '@seedlang/stores';
import { Site } from '@seedlang/models';
import CreateWithTitle from 'components/creator/create_with_title';

@observer
class MembershipTypeCreate extends React.Component {

  onCreate = name => {
    MembershipTypeStore.create({data: {name, site_id: Site.defaultSiteId()}});
  };

  render() {
    return (
      <CreateWithTitle
        placeholder='Add a name'
        onCreate={this.onCreate}
      />
    );
  }
}

export default MembershipTypeCreate;
